import type { OrderFulfillmentMethod } from '../enums/OrderFulfillmentMethod'
import type { OrderStatus } from '../enums/OrderStatus'
import type { OrderPaymentType } from '../enums/OrderPaymentType'
import type { OrderTag } from '@/features/trackOrder/domain/enums/OrderTag'
import type { OrderLiveAssignedDriverEntity } from '@/features/trackOrder/domain/entities/orderEntities/OrderLiveAssignedDriverEntity'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'
export class OrderMiniEntity {
  id?: string
  branchId?: number
  branchName?: string | null
  channelName?: string | null
  branchNote?: string | null
  driverNote?: string | null
  userId?: string
  userDisplayName?: string | null
  status?: OrderStatus
  invoiceSubTotal?: number
  createdAt?: string
  currentStatusSinceDate?: string
  invoiceTotal?: number
  trackingPanelUserId?: string
  trackingPanelUserDisplayName?: string | null
  fulfillmentMethod?: OrderFulfillmentMethod
  estimatedDeliveryDuration?: string
  referenceCode?: string | null
  paymentType?: OrderPaymentType
  updatedAt?: string
  assignedDriver?: OrderLiveAssignedDriverEntity
  tags?: OrderTag[]
  preparedAt?: string
  serviceId?: number
  scheduledOrderTime?: string | null
  serviceName?: string | null
  userHasUserNote?: boolean
  userLocationFarAwayFromUserAddress?: boolean

  hasUnavailableItem?: boolean
  shipmentDriver?: {
    id?: number
    workingPhoneNumber?: string | null
    fullName?: string | null
    vehicleTemplateType?: VehicleTemplateType
  }
}
